angular.module('bb.users').factory('userService', userService);

userService.$inject = ['$resource', '$rootScope', '$q', '$http'];

function userService($resource, $rootScope, $q, $http) {
  let repsById = null;

  // this returns all users for an org, it is your responsibility
  // to filter out users you do not want.
  const UserOrg = $resource('/user/org');

  const User = $resource('/user/:id', { id: '@id' });

  const UserCounts = $resource('/user/org/count');

  const Team = $resource('/team');

  const Locations = $resource('/org/locations');

  const FullUsers = $resource('/user/full');

  const Filestack = $resource('/file/filestack');

  const UserAuthActions = $resource('/user/actions/auth');

  const UserDefaultContacts = $resource('/user/default/contacts');

  const UserDefaultContact = $resource(
    '/user/default/contact/:userId/:contactId',
    {
      userId: '@userId',
      contactId: '@contactId',
    },
    {
      delete: {
        method: 'POST',
        url: '/user/default/contact/delete/:userId/:contactId',
      },
    },
  );

  const ApplyDefaultContact = $resource(
    '/user/default/apply/:userId/:contactId',
    {
      userId: '@userId',
      contactId: '@contactId',
    },
  );

  const AddTeamContact = $resource('/user/default/team/:userId', {
    userId: '@userId',
  });

  function getPendingByType(type) {
    return $resource(`/user/pending/${type}`).query().$promise;
  }

  function getUsers(queries) {
    return UserOrg.get(queries).$promise;
  }

  function getUserCounts() {
    return UserCounts.get().$promise;
  }

  function getTeams() {
    return Team.query().$promise;
  }

  function getLocations() {
    return Locations.get().$promise;
  }

  function getBasicUsers(targetIds, filter) {
    return $rootScope.fetchOrgUsers(filter, targetIds).then(users => {
      generateRepsById(users);
      return users;
    });
  }

  function generateRepsById(users) {
    repsById = { ...(repsById || {}) };
    users.forEach(user => {
      repsById[user.id] = user.label;
    });
  }

  function getUserNames(ids, filter) {
    if (!ids) return [];
    if (!repsById) {
      return getBasicUsers(ids, filter).then(() =>
        ids.map(id => repsById[id] || ''),
      );
    }

    const repsByIdSet = new Set(Object.keys(repsById));
    const missingIds = [...ids].filter(id => !repsByIdSet.has(id));

    if (missingIds.length) {
      return getBasicUsers(missingIds, filter).then(() =>
        ids.map(id => repsById[id] || ''),
      );
    }

    return $q.resolve(ids.map(id => repsById[id] || ''));
  }

  function deleteUser(userId) {
    return $http.post(`/user/delete/${userId}`);
  }

  function getDeleted() {
    return $resource('/user/deleted').query().$promise;
  }

  function saveUser(id, user) {
    return User.save({ id }, user).$promise;
  }

  function getUserById(id) {
    return User.get({ id }).$promise;
  }

  function getFullUsers(userIds) {
    return FullUsers.query({ userIds }).$promise;
  }

  function saveProfilePicture(data) {
    return Filestack.save(data).$promise;
  }

  const getAvatar = (id, type) => {
    const AVATAR_TYPES = {
      profile: 300,
      chat: 75,
    };
    const apiKey = 'AVsLFCmooSeCfsjDRz3Cbz';
    const src = new filestack.Filelink(id, apiKey);

    src.resize({ width: AVATAR_TYPES[type], height: AVATAR_TYPES[type] });

    return src.toString();
  };

  function getUserActions(userId, page) {
    return UserAuthActions.get({ page, userId }).$promise;
  }

  function getUserDefaultContacts(userId) {
    return UserDefaultContacts.get({ userId }).$promise;
  }

  function saveUserDefaultContact(contact) {
    return UserDefaultContact.save({
      ...contact,
      contactId: contact.contactId || contact.userId,
    }).$promise;
  }

  function deleteUserDefaultContact(userId, contactId) {
    return UserDefaultContact.delete({ userId, contactId }).$promise;
  }

  function applyUserDefaultContact(contact) {
    return ApplyDefaultContact.save({
      ...contact,
      contactId: contact.contactId || contact.userId,
    }).$promise;
  }

  function addTeamDefaultContact(userId) {
    return AddTeamContact.save({ userId }).$promise;
  }

  return {
    getBasicUsers,
    getUserNames,
    getUsers,
    getUserCounts,
    getTeams,
    getLocations,
    deleteUser,
    getPendingByType,
    getDeleted,
    getAvatar,
    saveUser,
    saveProfilePicture,
    getUserById,
    getFullUsers,
    getUserActions,
    getUserDefaultContacts,
    saveUserDefaultContact,
    deleteUserDefaultContact,
    applyUserDefaultContact,
    addTeamDefaultContact,
  };
}

export {};
